import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Constants } from "../../CommonMethhods/Constants";
import Header from "../../Components/Header";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Sidebar from "../../Components/Sidebar";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import Loader from "../../Components/Common/Loader";
import { toast } from "react-toastify";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import MarginTable from "../../Components/ReportTables/MarginTable";
import { useDebounce } from "../../Components/useDebounce";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import DurationChangeComponent from "./DurationChangeComponent";

function MarginReport() {
  const storeToken = localStorage.getItem("ssoToken");
  const [errorResp, setErrorResp] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [gridVal, setGridVal] = useState([]);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [page, setPage] = useState(1);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();
  const [clientCode, setClientCode] = useState("");
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const debouncedValue = useDebounce(clientCode, 1000);
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration, setSelectDuration]=useState("")
  useEffect(() => {
    setLoader(true);
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const getMarginReport = async (
    fileType,
    sizePage,
    pageNo = 1,
    mainLoader = false
  ) => {
    let clientCo = document.querySelector("#Margin_Report").value;
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
    }
    if (fileType === "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
    }
    if (mainLoader) {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setLoader(true);
    }
    let payloadValue = {
      fromDate: fromDate,
      toDate: toDate,
      clientCode: clientCo,
      fileType: fileType,
      pageNo: pageNo,
      pageSize: sizePage,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.Margin_Report_URL,

        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setCount(res?.data?.totalCount);
        setError(false);
        if (fileType === "grid") {
          if (pageNo > 1) {
            setGridVal((prev) => {
              return [...prev, ...res?.data?.marginShortageList];
            });
          } else {
            setGridVal(res?.data?.marginShortageList);
          }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setGridVal([]);
        if (fileType === "excel") {
          toast.error("No data available");
        } else if (fileType === "pdf") {
          toast.error("No data available");
        } else {
          setError(res?.message);
          setShow(false);
        }
      }
    } catch (error) {
      console.log(error);

      setServerError(error?.message);
      if (fileType === "excel") {
        toast.error(error?.message);
      }
      if (fileType === "pdf") {
        toast.error(error?.message);
      }
      if (clientCode !== "" && fileType === "grid") {
        toast.error(error?.message);
        setClientCode("");
      }
    } finally {
      setSmallLoaderExcel(false);
      setSearchLoader(false);
      setSmallLoaderPdf(false);
      setLoader(false);
      setScrollLoader(false);
    }
  };

  const handleFromDateChange = (e) => {
    // document.querySelector("#Margin_Report").value = "";
    setGridVal([]);
    // setClientCode("");
    setError(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    // document.querySelector("#Margin_Report").value = "";
    setGridVal([]);
    // setClientCode("");
    setError(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    setServerError("");
  };

  const handleScroll = (e) => {
    const a = document.querySelector("#margin-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  function handleClientName(data) {
    setGridVal([]);
    setError(false);
    setSearchLoader(true);
    getMarginReport("grid", 10, 1, data === "", data);
  }

  useEffect(() => {
    if (fromDate && toDate !== "") {
      if (page > 1) {
        getMarginReport("grid", 10, page, false);
      }
    }
  }, [page]);

  const handleOnClick = (e) => {
    if (selectDuration) {
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        if (e.target.value === "grid") {
          // document.querySelector("#Margin_Report").value = "";
          // setClientCode("");
          getMarginReport("grid", 10, 1, true);
          setErrorResp("");
        } else {
          if (e.target.value === "pdf") {
            getMarginReport("pdf", -1, 1, false);
          } else if (e.target.value === "excel") {
            getMarginReport("excel", -1, 1, false);
          }
        }
      } else {
        setLoader(false);
        setErrorResp("Please Select Correct Date");
      }
    }
    else{
      setErrorResp("Please Select Duration");
    }
    setPage(1);
  };

  const handleScrollUl = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !searchLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setSearchLoader(true);
      }
    }
  };

  const handleBlur = (e) => {
    setTimeout(() => {
      setShow(false);
    }, 200);
  };
  const onChangeDuration=()=>{
    setGridVal([]);
    setError(false);
    setErrorResp(false);
    setServerError(false);

  }
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box tentativeMargin-report">
          <div className="figure-inlac">
            <h2 className="report-title">{Constants.Margin_Report}</h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          </div>

          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-4 col-12">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                    <span className="duration-date-error">{errorResp}</span>
                  )}
            </div>

            {customShow && <div className="col-md-4 col-sm-4 col-12">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}
            {customShow && <div className="col-md-4 col-sm-4 col-12">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
                errorResponse={errorResp}
              />
            </div>}
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>
          <div className="d-flex justify-content-between">
            <div
              className="col-md-3 col-sm-3 col-6"
              onBlur={(e) => handleBlur(e)}
            >
              <div className="form-group">
                <label className="form-label">{Constants.Client_Code}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    id="Margin_Report"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScrollUl(e)}
                      >
                        {gridVal &&
                          gridVal.map((item, i) => (
                            <li
                              key={i}
                              className="rm-maping-item-wrapper"
                              onClick={() => {
                                document.querySelector("#Margin_Report").value =
                                  item.clientCode;

                                // setLoader(true);
                                setClientCode(item.clientCode);
                                setShow(false);
                              }}
                            >
                              <div> {item.clientName}</div>
                              <div> {item.clientCode}</div>
                            </li>
                          ))}
                        {searchLoader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div>
              <ReportTableHeader
                handleOnClick={handleOnClick}
                smallLoaderExcel={smallLoaderExcel}
                smallLoaderPdf={smallLoaderPdf}
              />
            </div>
          </div>

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : gridVal && gridVal.length > 0 ? (
              <>
                <div>
                  <MarginTable
                    error={error}
                    gridVal={gridVal}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                </div>
              </>
            ) : error ? (
              <h4 className="report-error-message">{noDataFound(error)}</h4>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default MarginReport;
